import { ActionTree } from "vuex";
import { BrandingState } from "./interfaces";
import { RootState } from "@/store/modules/root/interfaces";
import { FETCH_BRANDING, SET_BRANDING } from "./constants";
import { get_branding } from "@/store/apis/public";

const actions: ActionTree<BrandingState, RootState> = {
  /**
   * Fetch tenant branding by company slug and persist it. Best-effort: a failure
   * leaves the default (HCMS) branding untouched.
   */
  async [FETCH_BRANDING]({ commit }, slug: string) {
    // The slug comes straight off the URL query and external link builders
    // sometimes wrap it in quotes (?company="people-grid"), which never matches.
    const clean = String(slug || "")
      .trim()
      .replace(/^["']|["']$/g, "")
      .trim();
    if (!clean) return false;
    try {
      const response = await get_branding(clean);
      const data = response?.data?.data;
      if (data) {
        commit(SET_BRANDING, data);
        return true;
      }
    } catch {
      // ignore — fall back to default branding
    }
    return false;
  }
};

export default actions;
